import React from 'react';
import locales from '../../locales/LocalesManager';

export const NoAccessAlert = React.createClass({
    render () {
        const width = this.props.windowWidth - 200;
        const height = 200;

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: this.props.windowHeight / 2 - height / 2,
            left: this.props.windowWidth / 2 - width / 2
        };

        const spanStyle = {
            position: 'absolute',
            width: width,
            height: height,
            fontSize: 20,
            WebkitUserSelect: 'none',
            userSelect: 'none',
            textAlign: 'center',
            cursor: 'default',
            top: 0
        };

        var text = locales.getCaption('noAccessAlert', 'other');

        if (!text || text == '' || text == 'other.noAccessAlert')
            text = "Sorry! You don't have permissions for this product.";

        return (
            <div style={menuStyle}>
                <span style={spanStyle}>{text}</span>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/NoAccessAlert.js
 **/